import { createActions, createReducer } from 'reduxsauce'

import DetalhesContratoService from '../../servicos/DetalhesContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesContratoInicio: [],
    buscaDetalhesContratoSucesso: ['detalhesContrato'],
    buscaDetalhesContratoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDetalhesContrato = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesContratoInicio())
        let serv = new DetalhesContratoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesContratoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesContratoErro(error)))
    }
}

const buscaDetalhesContratoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhesContratoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDetalhesContratoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.detalhesContrato, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_CONTRATO_INICIO]: buscaDetalhesContratoInicio,
    [Types.BUSCA_DETALHES_CONTRATO_ERRO]: buscaDetalhesContratoErro,
    [Types.BUSCA_DETALHES_CONTRATO_SUCESSO]: buscaDetalhesContratoSucesso,
})
